const STATUS = {
  PROPOSED: 'proposed',
  DECLINED: 'declined',
  PASSIVE: 'passive',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

const DEVELOPMENT_STATUS = {
  IN_DANGER: 'in-danger',
  NEUTRAL: 'neutral',
  AWESOME: 'awesome'
};

const RATING_STATUS = {
  NOT_AVAILABLE: 'notAvailable',
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'completed'
};

const RATING_ROLE = {
  LEADER: 'leader',
  OWNER: 'owner'
};

const OBJECTIVE_STATUS_CHIP_LABELS = {
  PROPOSED: 'objective.status.proposed',
  DECLINED: 'objective.status.declined',
  PASSIVE: 'objective.status.passive',
  ACTIVE: 'objective.status.active',
  COMPLETED: 'objective.status.completed',
  FAILED: 'objective.status.failed',
  UNKNOWN: 'objective.status.unknown'
};

const RATING_CHIP_LABELS = {
  notAvailable: 'objective.evaluation.status.notAvailable',
  inProgress: 'objective.evaluation.status.inProgress',
  completed: 'objective.evaluation.status.completed'
};

const DEFAULT_OBJECTIVE_WEIGHT = '1';

const ERROR_MESSAGES = {
  NAME: 'objective.dialog.errorMessage.name',
  DESCRIPTION: 'objective.dialog.errorMessage.description',
  DEADLINE: 'objective.dialog.create.errorMessage.deadline',
  APPRAISER: 'objective.dialog.errorMessage.appraiser',
  CATEGORY: 'objective.dialog.errorMessage.category'
};

const DOUGHNUT_CHART_COLORS = {
  GREEN: '#99B64E',
  PURPLE: '#5744BB',
  BLUE: '#76C9E6'
};

const CRITERIA_TYPES = {
  BASIC: 'basic',
  ONLY_TEXT: 'only_text'
};

const SUPPORTED_LANGUAGES = {
  EN: 'en',
  HU: 'hu',
  DE: 'de'
};

const STATUS_TYPES = {
  DEVELOPMENT_STATUS: 'developmentStatus',
  STATUS: 'status'
};

const EVENT_LOG_LIMIT = 10;

const EVENT_LOG_ACTIONS = {
  CREATE: 'create'
};

const OWNER_TYPES = {
  EMPLOYEE: 'employee',
  GROUP: 'group'
};

const OBJECTIVES_INFO_TYPES = {
  WILL_EXPIRE: 'willExpire',
  EXPIRED: 'expired',
  PROPOSED: 'proposed',
  ACTIVE: 'active',
  NEUTRAL: 'neutral',
  AWESOME: 'awesome',
  IN_DANGER: 'inDanger'
};

// same as sm for materialUI breakpoint
const SCREEN_BREAK_POINT = 960;

const NAVIGATION_DRAWER_WIDTH = 190;

const OBJECTIVE_RELATION_TYPES = {
  HIERARCHICAL: 'hierarchical'
};

const UNAUTHORIZED_ERROR = 'unauthorized_request_error';

const PRIVACY_POLICY = 'https://www.cx-ray.com/adatkezelesi-tajekoztato/';

const MAX_ATTACHMENT_SIZE = 25;

const LOCATIONS = {
  HOME: '/',
  OBJECTIVES: '/objectives',
  MISSING_LICENCE: '/missing-licence',
  REGISTRATION: '/registration/:hash'
};

const EVENT_LOG = {
  OBJECTIVES: 'objectives',
  COMMENTS: 'comments',
  KPIS: 'kpis',
  KPI_ENTRIES: 'kpi_entries',
  PROPERTIES: {
    LOCKED_EVALUATION: 'lockedEvaluation'
  },
  ACTIONS: {
    DELETE: 'delete'
  }
};

const ALREADY_REGISTERED_ERROR = 'already_registered';

module.exports = {
  STATUS,
  RATING_STATUS,
  RATING_ROLE,
  OBJECTIVE_STATUS_CHIP_LABELS,
  RATING_CHIP_LABELS,
  DEFAULT_OBJECTIVE_WEIGHT,
  ERROR_MESSAGES,
  DOUGHNUT_CHART_COLORS,
  CRITERIA_TYPES,
  SUPPORTED_LANGUAGES,
  DEVELOPMENT_STATUS,
  STATUS_TYPES,
  EVENT_LOG_LIMIT,
  EVENT_LOG_ACTIONS,
  SCREEN_BREAK_POINT,
  NAVIGATION_DRAWER_WIDTH,
  OBJECTIVES_INFO_TYPES,
  OWNER_TYPES,
  OBJECTIVE_RELATION_TYPES,
  UNAUTHORIZED_ERROR,
  PRIVACY_POLICY,
  MAX_ATTACHMENT_SIZE,
  LOCATIONS,
  EVENT_LOG,
  ALREADY_REGISTERED_ERROR
};
